// Escritura única del patrón "precio acordado" (FRA-340). Actualiza el
// valor vigente denormalizado en el doc dueño y asienta el registro en su
// subcolección `costoHistorial` en el MISMO batch: si se guardara el valor
// sin su registro, la diferencia con los snapshots viejos quedaría sin
// explicación para siempre. Un valor vigente sin historial es imposible
// por construcción.
//
// Los tres precios acordados del sistema pasan por aquí: tarifa del
// proveedor (utils/servicios.js), comisión de planner (utils/comisiones.js)
// y gasto recurrente (utils/recurrentes.js). Cada caller decide cómo se ve
// su valor vigente (`vigentePatch`);
// el registro del historial siempre tiene la misma forma
// (utils/historialPrecios.js).
import {
  collection,
  doc,
  serverTimestamp,
  Timestamp,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";
import { registroPrecio } from "./historialPrecios";

// Asienta SOLO el registro del historial dentro de un batch que el caller ya
// tiene abierto (alta de un renglón, clasificación desde el wizard, edición
// que además toca otros campos). El caller escribe el valor vigente en su
// propio set/update del mismo batch; así el par valor+historial sigue siendo
// atómico sin que cada pantalla arme el registro a mano. Devuelve la ref
// del registro, o null si no hay quién firme.
export function asentarPrecioAcordado(
  batch,
  {
    docRef,
    monto,
    montoAnterior = 0,
    notas = null,
    user = null,
    userInfo = null,
    ahora = null,
    subcoleccion = "costoHistorial",
    extra = null,
  }
) {
  if (!batch || !docRef || !user?.uid) return null;
  const histRef = doc(collection(docRef, subcoleccion));
  batch.set(histRef, {
    ...registroPrecio({
      monto,
      montoAnterior,
      notas,
      uid: user.uid,
      nombre: userInfo?.name || "",
      ahora: ahora || Timestamp.now(),
    }),
    ...(extra || {}),
  });
  return histRef;
}

export async function setPrecioAcordado({
  docRef, // DocumentReference del doc dueño del precio vigente
  vigentePatch, // campos a escribir en ese doc (el valor denormalizado)
  monto,
  montoAnterior = 0,
  notas = null,
  user = null,
  userInfo = null,
  ahora = null, // Timestamp compartido con el patch del caller, si lo necesita
  subcoleccion = "costoHistorial",
  extra = null, // campos adicionales del registro (p. ej. eventId de una comisión)
}) {
  if (!docRef || !user?.uid) return null;
  const batch = writeBatch(db);
  batch.update(docRef, {
    ...vigentePatch,
    updatedAt: serverTimestamp(),
    updatedBy: user.uid,
  });
  const histRef = asentarPrecioAcordado(batch, {
    docRef,
    monto,
    montoAnterior,
    notas,
    user,
    userInfo,
    ahora,
    subcoleccion,
    extra,
  });
  await batch.commit();
  return histRef.id;
}
